import { render } from "./RecentGames.vue?vue&type=template&id=d59553f0&scoped=true"
import script from "./RecentGames.vue?vue&type=script&lang=js"
export * from "./RecentGames.vue?vue&type=script&lang=js"

import "./RecentGames.vue?vue&type=style&index=0&id=d59553f0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59553f0"]])

export default __exports__